import Button from '../common/button.tsx';
import QuestionsBrowser from './questions-browser/questions-browser.tsx';
import Modal from '../common/modal.tsx';
import { Dispatch, SetStateAction } from 'react';

interface IProps {
  insertAtIndex?: number | null;
  questionToChange?: number | null;
  open: boolean;
  onClose: () => void;
  selectedQuestions: number[];
  setSelectedQuestion: Dispatch<SetStateAction<number[]>>;
  onInsertQuestion?: (newId: number) => void;
  onChangeQuestion?: (newId: number) => void;
  onAddQuestions: (newId: number[]) => void;
}
const AddQuestionsModal = ({
  insertAtIndex,
  questionToChange,
  open,
  onClose,
  selectedQuestions,
  setSelectedQuestion,
  onInsertQuestion,
  onAddQuestions,
  onChangeQuestion,
}: IProps) => {
  const isSingleSelectMode =
    typeof questionToChange === 'number' || typeof insertAtIndex === 'number';

  return (
    <Modal
      title={
        questionToChange
          ? 'Change question'
          : typeof insertAtIndex === 'number'
            ? 'Insert question'
            : 'Add question'
      }
      description={
        isSingleSelectMode ? 'Select one question' : 'Select one or more questions'
      }
      isOpen={open}
      onClose={onClose}
      fullScreen
    >
      <div>
        <Button
          onClick={
            questionToChange && onChangeQuestion
              ? () => onChangeQuestion(selectedQuestions[0])
              : typeof insertAtIndex === 'number' && onInsertQuestion
                ? () => onInsertQuestion(selectedQuestions[0])
              : () => onAddQuestions(selectedQuestions)
          }
          disabled={
            !selectedQuestions.length ||
            (isSingleSelectMode && selectedQuestions.length !== 1)
          }
          className={'ml-auto mt-2'}
        >
          {questionToChange
            ? 'Change question'
            : typeof insertAtIndex === 'number'
              ? 'Insert question'
            : selectedQuestions.length > 1
              ? 'Add questions'
              : 'Add question'}
        </Button>
        <QuestionsBrowser
          isModalMode={true}
          setSelectedQuestion={setSelectedQuestion}
        />
      </div>
    </Modal>
  );
};
export default AddQuestionsModal;
